import { render, staticRenderFns } from "./DeliveryInProcessRow.vue?vue&type=template&id=447ef916&scoped=true&"
import script from "./DeliveryInProcessRow.vue?vue&type=script&lang=js&"
export * from "./DeliveryInProcessRow.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInProcessRow.vue?vue&type=style&index=0&id=447ef916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ef916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItemAvatar})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
